var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHurrah(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3481_9161",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 88,
    height: 88
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3481_9161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9776 29.5057C28.4232 36.3175 24.7617 47.1955 19.7885 61.9503C18.8189 64.5359 20.1289 67.4179 22.7145 68.3875C23.8617 68.8177 25.1269 68.8117 26.2699 68.3707C40.6342 63.0439 51.312 59.1949 58.0677 56.5884",
    stroke: "#449DFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7782 55.0564C64.6834 51.1512 61.5176 41.6537 53.7071 33.8432C45.8966 26.0327 36.3992 22.8669 32.4939 26.7721C28.5887 30.6774 31.7545 40.1748 39.565 47.9853C47.3755 55.7958 56.8729 58.9616 60.7782 55.0564Z",
    stroke: "#449DFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5251 7.32666C50.5251 7.32666 51.9394 21.4688 40.9792 35.2574",
    stroke: "#A9AEFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5962 21.4688C56.5355 25.3579 51.5858 33.1361 45.2218 39.5",
    stroke: "#A9AEFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9307 37.7322C80.9307 37.7322 66.7885 36.318 52.9999 47.2782",
    stroke: "#A9AEFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7886 30.6612C62.8995 31.7219 55.1213 36.6716 48.7574 43.0356",
    stroke: "#A9AEFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5523 30.2023C83.3705 30.2023 84.0338 29.539 84.0338 28.7208C84.0338 27.9026 83.3705 27.2393 82.5523 27.2393C81.7341 27.2393 81.0708 27.9026 81.0708 28.7208C81.0708 29.539 81.7341 30.2023 82.5523 30.2023Z",
    fill: "#56A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2005 9.99812C60.0187 9.99812 60.682 9.33484 60.682 8.51664C60.682 7.69844 60.0187 7.03516 59.2005 7.03516C58.3823 7.03516 57.719 7.69844 57.719 8.51664C57.719 9.33484 58.3823 9.99812 59.2005 9.99812Z",
    fill: "#56A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2745 53.2574C70.0926 53.2574 70.7559 52.5941 70.7559 51.7759C70.7559 50.9577 70.0926 50.2944 69.2745 50.2944C68.4563 50.2944 67.793 50.9577 67.793 51.7759C67.793 52.5941 68.4563 53.2574 69.2745 53.2574Z",
    fill: "#56A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2005 63.3685C62.3871 63.3685 61.719 64.0366 61.719 64.85C61.719 65.6633 62.3871 66.3314 63.2005 66.3314C64.0138 66.3314 64.682 65.6633 64.682 64.85C64.682 64.0221 64.0284 63.3685 63.2005 63.3685Z",
    fill: "#56A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5411 16.3621C41.3593 16.3621 42.0225 15.6988 42.0225 14.8806C42.0225 14.0624 41.3593 13.3991 40.5411 13.3991C39.7229 13.3991 39.0596 14.0624 39.0596 14.8806C39.0596 15.6988 39.7229 16.3621 40.5411 16.3621Z",
    fill: "#56A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.7324 59.2322C80.3893 59.2322 81.7324 57.8891 81.7324 56.2322C81.7324 54.5754 80.3893 53.2322 78.7324 53.2322C77.0756 53.2322 75.7324 54.5754 75.7324 56.2322C75.7324 57.8891 77.0756 59.2322 78.7324 59.2322Z",
    stroke: "#FF6161",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3864 17.6123L69.3243 22.0682C69.483 22.8339 70.2349 23.3321 71.0122 23.1594C71.7792 22.9962 72.2726 22.2315 72.1139 21.4658L71.4112 18.1042L74.3048 18.9277C75.0379 19.1388 75.8357 18.947 76.399 18.4216L76.44 18.3834C76.9419 17.9154 77.2049 17.2323 77.1317 16.5581L76.8778 14.1296L78.0377 14.552C79.1486 14.9629 80.3733 14.7155 81.244 13.9036L81.7356 13.4452C82.3093 12.9103 82.3436 12.0025 81.8119 11.4323C81.2802 10.862 80.3722 10.833 79.7986 11.3679L79.3069 11.8264C79.2352 11.8933 79.1255 11.9194 79.0378 11.887L76.8745 11.0868C75.3449 10.5143 73.7654 11.7777 73.9322 13.3736L74.2013 15.9211L71.1316 15.0525C69.5477 14.6067 68.0522 16.0012 68.3864 17.6123Z",
    fill: "#FFAA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7324 18.2322C28.837 18.2322 29.7324 17.3368 29.7324 16.2322C29.7324 15.1277 28.837 14.2322 27.7324 14.2322C26.6279 14.2322 25.7324 15.1277 25.7324 16.2322C25.7324 17.3368 26.6279 18.2322 27.7324 18.2322Z",
    stroke: "#F188DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurrah);
export default __webpack_public_path__ + "static/media/hurrah.dc414da63d60867d11dd4667d439d60e.svg";
export { ForwardRef as ReactComponent };